const getters = {
	accountInfoData: state => state.accountInfo.accountInfoData,
	superPreventOperation: state => state.accountInfo.superPreventOperation
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js